import { Component, OnInit } from '@angular/core';
import { SidePanelService } from '../../services/side-pannel/side-pannel.service';
import { ReportService } from 'src/app/repository/service/report.service';
import { HomeService } from '../../services/home.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sub-side-nav',
  templateUrl: './sub-side-nav.component.html',
  styleUrls: ['./sub-side-nav.component.scss']
})
export class SubSideNavComponent implements OnInit {
  private activeRoutes = ['qa-report/rejection-on-yoy','qa-report/rejection-on-qoq','qa-report/rejection-by-field','qa-report/rejection-by-eic','qa-report/rejection-by-job','qa-report/rejection-by-interviewer'];
  constructor(
    public sidePanelService:SidePanelService,
    public reportService:ReportService,
    public homeService: HomeService,
    public router: Router
    ) { }

  ngOnInit(): void {

  }

  test(){
    // console.log("sidePanelService.sideDrawer.subMenu === >>",this.sidePanelService.sideDrawer.subMenu)
    // console.log("sidePanelService.sideDrawer === >>",this.sidePanelService.sideDrawer)
  }

  checkActiveClass(subMenu?: any){
    // Check for QA report active routes
    const isActiveRoute = this.activeRoutes.some(route => this.router.url.includes(route));
    if (isActiveRoute) {
      return true;
    }
    
    // For tree menus (repo), check if current URL matches the submenu's route (parent detail page)
    if (subMenu && subMenu.isTree && subMenu.routerLink) {
      if (this.router.url.includes(subMenu.routerLink)) {
        return true;
      }
    }
    
    // Check if any dropdown file's UUID is in the current URL
    if (subMenu && subMenu.dropDown && subMenu.dropDown.length > 0) {
      return subMenu.dropDown.some(dropMenu => 
        dropMenu.uuid && this.router.url.includes(dropMenu.uuid)
      );
    }
    
    return false;
  }

  openSubMenuHighlighter(item){
    if(item.type == 'video'){
      this.sidePanelService.openSubMenuHighlighter('video');
    }else{
      this.sidePanelService.openSubMenuHighlighter('pdf');
    }

  }

  toggelDropdown(subMenu,index){
    let route = subMenu['dropdown_route'] && subMenu['dropdown_route'] !== '' ? subMenu['dropdown_route'] : subMenu['route'];
    this.sidePanelService.navigateMenu(route,index);
  }


}
